import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Leads from "./components/lead_and_quotation/Leads";
import QualifiedLeads from "./components/lead_and_quotation/QualifiedLeads";
import Contacts from "./components/lead_and_quotation/Contacts";
import Emails from "./components/lead_and_quotation/Emails";
import Settings from "./components/lead_and_quotation/Settings";
import LeadForm from "./components/lead_and_quotation/LeadForm";
import AllEntriesForm from "./components/lead_and_quotation/allEntriesForm";
import Home from "./components/lead_and_quotation/Home";
import Deals from "./components/lead_and_quotation/Deals";
import QuotationComponent from "./modals/QuoteLead";
import QuotationComponentAdmin from "./modals/QuoteLeadAdmin";
import { BreadcrumbsProvider } from "./modals/BreadcrumbsContext";
import Quotations from "./components/lead_and_quotation/Quotations";
import QuotationPage from "./components/lead_and_quotation/QuotationPage";
import StockList from "./components/lead_and_quotation/StockList";
import LoginPage from "./components/lead_and_quotation/LoginPage";
import QuotationsListViewFull from "./modals/QuotationsListViewFull";
import ConvertToSalesOrderScreen from "./modals/ConverToSalesOrderScreen";
import SalesOrderListViewFull from "./modals/SalesOrderListViewFull";
import SalesOrderDetailsUser from "./modals/SalesOrderDetailsUser";
import SalesOrderDetailsAdmin from "./modals/SalesOrderDetailsAdmin";
import SampleApprovalListViewFull from "./modals/SampleApprovalListViewFull";
import WorkOrderApprovalListViewFull from "./modals/WorkOrderApprovalListViewFull";
import ProtectedRouteMachine from "./components/lead_and_quotation/ProtectedRouteMachine.js";
import ProtectedRouteLogin from "./components/lead_and_quotation/ProtectedRouteLogin.js";
import { Navigate, Outlet } from "react-router-dom";

import MachineRegistration from "./components/lead_and_quotation/MachineRegistration.js";
import "./css/App.css";
import NotFound from "./components/lead_and_quotation/NotFound.js";

import InvoiceList from "./components/invoiceList/InvoiceList.js";
// import LandingPage from "./components/landingPage/LandingPage.js";

import UnifiedSalesInvoice from "./components/salesInvoice/UnifiedSalesInvoice.js";
import DoList from "./components/invoiceList/DoList.js";
import SalesOrder from "./components/salesInvoice/SalesOrder.js";
import SalesOrderList from "./components/invoiceList/SalesOrderList.js";
import UnifiedDeliveryOrder from "./components/salesInvoice/UnifiedDeliveryOrder.js";
import UnifiedQuotation from "./components/salesInvoice/UnifiedQuotation.js";
import QuotationList from "./components/invoiceList/QuotationList.js";
import SalesReturn from "./components/salesReturn/SalesReturn.js";
import SalesReturnList from "./components/salesReturn/SalesReturnList.js";
import PurchaseInvoice from "./components/purchaseInvoice/PurchaseInvoice.js";
import PurchaseInvoiceList from "./components/purchaseInvoice/PurchaseInvoiceList.js";
import ProductListing from "./components/salesInvoice/ProductsModal.js";

import Roles from "./customer_control/Roles";
import Users from "./customer_control/Users";
import UserRights from "./customer_control/UserRights";
import HtmlEditor from "./customer_control/HtmlEditor";
import GLVoucherSettings from "./customer_control/GLVoucherSettings";
import GroupAndLedgerManagement from "./customer_control/GroupAndLedgerManagement";
import BusinessPartner from "./customer_control/BusinessPartner";
import BusinessPartnerRegister from "./customer_control/BusinessPartnerRegister";

import Jobs from "./taskManagement/Jobs.js";
import Templates from "./taskManagement/Templates.js";
import JobsDashboard from "./taskManagement/JobsDashboard.js";
import NewJobForm from "./taskManagement/NewJobForm.js";
import Animated404page from "./taskManagement/Animated/Animated404page.js";
import Statements from "./StatementsFolder/statements.js";
import { StatementDocument } from "./StatementsFolder/StatementPDF.js";
import StatementPreview from "./StatementsFolder/StatementPreview.js";
import Reciept from "./RecieptFolder/Reciept.js";
import Payment from "./PaymentFolder/Payment.js";
import Voucher from "./VoucherFolder/Voucher.js";
import VoucherView from "./VoucherFolder/VoucherView.js";
import PaymentPreview from "./PaymentFolder/PaymentPreview.js";
import PaymentView from "./PaymentFolder/PaymentView.js";
import RecieptView from "./RecieptFolder/RecieptView.js";
import RecieptDocument from "./RecieptFolder/RecieptDocument.js";
import RecieptPreview from "./RecieptFolder/RecieptPreview.js";

import VoucherPrint from "./VoucherFolder/VoucherPrint.js";
import CustomerCreation from "./CustomerCreation/CustomerCreation.js";
import CustomerView from "./CustomerCreation/CustomerView.js";
import BusinessPartnersDashboard from "./components/BusinessPartners/BusinessPartnersDashboard.js";
import SupplierCreation from "./components/SupplierCreation/SupplierCreation.js";
import PDCDashboard from "./components/PDCDirectory/PDCDashboard.js";
import VoucherAnalysis from "./components/VoucherAnalysisDirectory/VoucherAnalysis.js";
import PDCReportPrint from "./components/PDCDirectory/PDCReportPrint.js";
import PettyCash from "./components/PettyCashDirectory/PettyCash.js";
import PettyCashView from "./components/PettyCashDirectory/PettyCashView.js";
import PettyCashPrint from "./components/PettyCashDirectory/PettyCashPrint.js";
import ItemCreation from "./components/ItemCreationDirectory/ItemCreation.js";
import { PreviousRouteProvider } from "./utils/RouteTracker.jsx";
import TrialBalanceReport from "./financial_reports/TrialBalanceReport.js";
import BalanceSheetReport from "./financial_reports/BalanceSheetReport.js";
import ProfitAndLossReport from "./financial_reports/ProfitAndLossReport.js";
import SalesAnalysisReport from "./reports/sales_analysis_report/SalesAnalysisReport.js";
import InvoiceProfitAnalysisReport from "./reports/InvoiceProfitAnalysis/InvoiceProfitAnalysisReport.js";
import PurchaseOrder from "./components/purchaseOrder/PurchaseOrder.js";
import PurchaseOrderList from "./components/purchaseOrder/PurchaseOrderList.js";
import WorkOrder from "./components/workOrder/WorkOrder.js";
import DistributionDashboard from "./components/distributionDashboard/DistributionDashboard.js";
import ProductionDashboard from "./components/productionDashboard/ProductionDashboard.js";
import SampleIssue from "./components/sampleIssue/SampleIssue.js";
import SalespersonCreation from "./components/SalespersonCreationDirectory/SalespersonCreation.js";
import CoordinatorCreation from "./components/CoordinatorCreationDirectory/CoordinatorCreation.js";
import FinanceDashboard from "./components/FinanceDashboardDirectory/FinanceDashboard.js";

import SampleIssueList from "./components/sampleIssue/SampleIssueList.js";
import SampleReturnList from "./components/sampleReturn.js/SampleReturnList.js";
import SampleReturn from "./components/sampleReturn.js/SampleReturn.js";
import PurchaseAnalysisReport from "./reports/purchase_analysis_report/PurchaseAnalysisReport.js";
import StockLedgerMovement from "./components/StockLedgerMovementDirectory/StockLedgerMovement.js";
import DeliveryOrderReports from "./components/DeliveryOrderReportsDirectory/DeliveryOrderReports.js";
import VATReport from "./reports/vat_report/VATReport.js";
import StockReport from "./reports/stock_report/StockReport.js";
import SalesOrderReports from "./components/SalesOrderReportsDirectory/SalesOrderReport.js";
import Production from "./components/productionDashboard/Production.js";
import LocationTransfer from "./components/locationTransfer/LocationTransfer.js";
import LocationTransferList from "./components/locationTransfer/LocationTransferList.js";
import BankReconciliation from "./components/BankReconciliationDirectory/BankReconciliation.js";
import StockTransfer from "./components/stockTransfer/StockTransferIn.js";
import { DOCUMENT_TYPES } from "./components/config/DocumentConfig.js";
import FinancialAnalysisReport from "./components/FinancialAnalysisReportDirectory/FinancialAnalysisReport.js";
import BillAllocation from "./components/BillAllocationDirectory/BillAllocation.js";
import PhysicalStockEntry from "./components/physicalStock/PhysicalStockEntry.js";
import PhysicalStockView from "./components/physicalStock/PhysicalStockView.js";
import PurchaseReturn from "./components/purchase return/PurchaseReturn.js";
import BudgetAllocation from "./components/budget/BudgetAllocation.js";
import BudgetAnalysis from "./components/budget/BudgetAnalysis.js";
import WorkOrderList from "./components/workOrder/WorkOrderList.js";
import DoLogisticList from "./components/invoiceList/DoLogisticList.js";
import LogisticManagementDashboard from "./components/LogisticManagement/LogisticManagementDashboard.js";
import SalesDashboard from "./components/SalesDirectory/SalesDashboard.js";
import FinanceMainDashboard from "./components/FinanceMainDashboardDirectory/FinanceMainDashboard.js";
import HomeNew from "./components/FinanceMainDashboardDirectory/NewFinanceDashboardDirectory/HomeNew.jsx";

import AssetRegisterList from "./components/asset/AssetRegisterList.js";
import RegisterAsset from "./components/asset/RegisterAsset.js";
import StockUpload from "./components/stock/StockUpload.js";
import StockManagement from "./components/stock/StockManagement.js";
import VisitManager from "./components/customerVisitEntry/VisitManager.js";
import AssembleDisamble from "./components/productionDashboard/AssembleDisamble.js";
import CRMStageReport from "./components/SalesOrderReportsDirectory/CRMStageReport.js";
import SalesmanPerformanceReport from "./components/SalesOrderReportsDirectory/SalesmanPerformanceReport.js";
import ContractQuotationScreen from "./contractQuotation/ContractQuotation.js";
import ChequeRegister from "./components/chequePrint/ChequeRegister.js";
import ContractDashboard from "./contractQuotation/ContractDashboard.js";
import ProjectsDashboard from "./components/ProjectsDashboardDirectory/ProjectsDashboard.js";
// import AiTutor from "./components/aiTutor/AiTutor.js";
import StockTransferOutList from "./components/stockTransfer/StockTransferOutList.js";
import StockTransferInList from "./components/stockTransfer/StockTransferInList.js";
import GitHome from "./components/goodsInTransit/GitHome.js";
import WarrantyClaim from "./components/warrentyClaim/WarrentyClaim.js";
import WarrantyClaimList from "./components/warrentyClaim/WarrentyClaimList.js";
import GitList from "./components/goodsInTransit/GitList.js";
import ApplicationUtilities from "./components/applicationUtilities/ApplicationUtilities.js";
import JobForm from "./components/workOrder/JobForm.js";
import PriceUpdater from "./components/priceUpdater/PriceUpdater";
import OutstandingPreview from "./StatementsFolder/OutstandingPreview.js";
import CompanyTabAdmin from "./customer_control/CompanyTabAdmin.jsx";
import DeviceDetails from "./customer_control/DeviceDetails.jsx";
import BranchTransferList from "./components/stockTransfer/BranchTransferList.js";
import BranchTransferInList from "./components/stockTransfer/BranchTransferInList.js";
import PriceManager from "./priceManager/PriceManager.js";
import UnitMaster from "./components/mastercreation/UnitMaster.js";
import AreaCodeMaster from "./components/mastercreation/AreaCodeMaster.js";
import CurrencyMaster from "./components/mastercreation/CurrencyMaster.js";
import SalesmanMaster from "./components/mastercreation/SalesmanMaster.js";
import SubgroupMaster from "./components/mastercreation/SubgroupMaster.js";
import GroupMaster from "./components/mastercreation/GroupMaster.js";
import CategoryMaster from "./components/mastercreation/CategoryMaster.js";
import SubcategoryMaster from "./components/mastercreation/SubCategoryMaster.js";
import LocationMaster from "./components/mastercreation/LocationMaster.js";
import CommonMasterCreation from "./components/mastercreation/CommonMasterCreation.js";
import QuotationReport from "./reports/quotation_report/QuotationReport.js";
import ItemCreationAutoParts from "./components/ItemCreationDirectory/ItemCreationAutoParts.js";
import PurchaseEnquiry from "./components/purchaseEnquiry/PurchaseEnquiry.js";
import PurchaseEnquiryList from "./components/purchaseEnquiry/PurchaseEnquiryList.js";
import BillAllocationMultiple from "./components/BillAllocationDirectory_Multiple/BillAllocationMultiple.js";
import PurchaseReturnList from "./components/purchase return/PurchaseReturnList.js";
// import ItemCreationAutoParts from "./components/ItemCreationDirectory/tabs/ItemCreationAutoParts.js";
// RealEstate
import BuildingRegister from "./RealEstateDirectory/Pages/BuildingRegister.jsx";
import RentalUnitDashboard from "./RealEstateDirectory/Pages/RentalUnitsDashboard.jsx";
import TenantRegister from "./RealEstateDirectory/Pages/TenantRegister.jsx";
import TenantCreation from "./RealEstateDirectory/Pages/TenantCreation.jsx";
import RSRV from "./RealEstateDirectory/Pages/RSRV.jsx";
import TenancyContractRegister from "./RealEstateDirectory/Pages/TenancyContractRegister.jsx";
import TenancyContractList from "./RealEstateDirectory/Pages/TenancyContractList.jsx";

import ContractAnalysis from "./RealEstateDirectory/Pages/ContractAnalysis.jsx";
import RSInspection from "./RealEstateDirectory/Pages/RSInspection.jsx";
import RSDashboard from "./RealEstateDirectory/Pages/RSDashboard.jsx";
import ReceiptRealEstate from "./RealEstateDirectory/Pages/ReceiptRealEstate.jsx";
import EInvoicingDashboard from "./components/e_invoicing/EInvoicingDashboard.jsx";
import NewReceipt from "./RealEstateDirectory/Pages/NewReceipt.jsx";
import RentalUnitDashboardWrapper from "./RealEstateDirectory/Pages/RentalUnitsDashboard.jsx";
import RecieptPreviewRE from "./RealEstateDirectory/Pages/ReceiptPreviewRE.jsx";
import ContractingQuotation from "./contractQuotation/ContractQuotation.js";
import ReportDesignerPage from "./report_designer/ReportDesignerPage.jsx"
// RealEstate

// Admin-only route guard
const AdminRoute = () => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "[]");
  const isAdmin = currentUser[0]?.accessgrp?.trim()?.toUpperCase() === "ADMIN";
  return isAdmin ? <Outlet /> : <Navigate to="/home" replace />;
};

function AppContent() {
  const [rowsPerPage, setRowsPerPage] = useState("5");
  const location = useLocation(); // 2. Track the active page URL context

  useEffect(() => {
    // Grab version from your package or environment setup
    const CURRENT_RUNNING_VERSION = process.env.REACT_APP_VERSION;

    async function checkForUpdates() {
      try {
        // Append unique timestamp to bypass IIS caching completely
        const res = await fetch(`/version.json?t=${new Date().getTime()}`, {
          headers: { "Cache-Control": "no-cache", Pragma: "no-cache" },
        });
        const serverData = await res.json();

        // console.log(`[Router Check] Server: ${serverData.version} | Browser Running: ${CURRENT_RUNNING_VERSION}`);

        if (
          serverData &&
          serverData.version &&
          serverData.version !== CURRENT_RUNNING_VERSION
        ) {
          triggerForceUpdateBanner();
        }
      } catch (err) {
        console.error("Error checking server version on route change:", err);
      }
    }

    function triggerForceUpdateBanner() {
      if (document.getElementById("erp-update-banner")) return;

      const banner = document.createElement("div");
      banner.id = "erp-update-banner";
      banner.style.cssText = `
          position: fixed; bottom: 24px; right: 24px; 
          background: #1e293b; color: #f8fafc; padding: 16px 20px; 
          border-radius: 12px; box-shadow: 0 10px 25px -5px rgba(0,0,0,0.3);
          z-index: 99999; display: flex; align-items: center; gap: 16px;
          font-family: system-ui, sans-serif; border: 1px solid #334155;
      `;

      banner.innerHTML = `
          <span style="font-size: 14px; font-weight: 500;">A new SALESDOOD update is available.</span>
          <button id="update-btn" style="background: #2563eb; color: white; border: none; padding: 8px 16px; border-radius: 6px; font-weight: 600; cursor: pointer;">
              Update Now
          </button>
      `;

      document.body.appendChild(banner);

      document.getElementById("update-btn").addEventListener("click", () => {
        if (caches && caches.keys) {
          caches.keys().then((names) => {
            for (let name of names) caches.delete(name);
          });
        }
        window.location.reload(true);
      });
    }

    // 3. Trigger the check execution immediately
    checkForUpdates();
  }, [location.pathname]);
  return (
    <div className="flex lg:h-screen max-h-[100vh] overflow-y-auto scrollbar-thin">
      <div className="flex-1 flex flex-col lg:h-screen ">
        <main className="flex-1  " style={{ backgroundColor: "#f8f8f8 " }}>
          <Routes>
            <Route path="/">
              <Route element={<ProtectedRouteMachine />}>
                {/* if machine registered can come inside else go to machine registration */}
                <Route path="" element={<LoginPage />} />

                <Route element={<ProtectedRouteLogin />}>
                  {/* All other routes that you want to protect will go inside here */}
                  <Route path="/leads" element={<Leads />} />
                  <Route
                    path="qualifiedLeadsTable"
                    element={<QualifiedLeads />}
                  />
                  <Route path="contacts" element={<Contacts />} />
                  <Route path="emails" element={<Emails />} />
                  <Route
                    path="settings"
                    element={
                      <Settings
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                      />
                    }
                  />
                  <Route path="leadForm" element={<LeadForm />} />
                  <Route path="allEntriesForm" element={<AllEntriesForm />} />
                  <Route path="/home" element={<Home />} />
                  <Route
                    path="deals"
                    element={<Deals rowsPerPage={rowsPerPage} />}
                  />
                  <Route path="quotations" element={<Quotations />} />
                  <Route
                    path="quotationsListViewFull"
                    element={<QuotationsListViewFull />}
                  />
                  <Route
                    path="salesOrderListViewFull"
                    element={<SalesOrderListViewFull />}
                  />
                  <Route
                    path="sampleRequestListViewFull"
                    element={<SampleApprovalListViewFull />}
                  />
                  <Route
                    path="workOrderListViewFull"
                    element={<WorkOrderApprovalListViewFull />}
                  />
                  <Route path="quotationPage" element={<QuotationPage />} />
                  <Route path="stockList" element={<StockList />} />
                  <Route path="quoteLead" element={<QuotationComponent />} />
                  <Route
                    path="quoteLead"
                    element={<QuotationComponentAdmin />}
                  />
                  <Route
                    path="convert_to_sales_order"
                    element={<ConvertToSalesOrderScreen />}
                  />
                  {/* ------------ Athul ------------- */}
                  <Route
                    path="sales_order_details_user"
                    element={<SalesOrderDetailsUser />}
                  />
                  <Route
                    path="sales_order_details_admin"
                    element={<SalesOrderDetailsAdmin />}
                  />
                  <Route
                    path="/sales_invoice"
                    element={<UnifiedSalesInvoice />}
                  />{" "}
                  <Route
                    path="/delivery_order"
                    element={<UnifiedDeliveryOrder />}
                  />
                  <Route
                    path="/quotation_entry"
                    element={<UnifiedQuotation />}
                  />
                  <Route path="/sales_return" element={<SalesReturn />} />
                  <Route path="/sales_order" element={<SalesOrder />} />{" "}
                  <Route
                    path="/purchase_invoice"
                    element={<PurchaseInvoice />}
                  />
                  <Route path="/purchase_order" element={<PurchaseOrder />} />{" "}
                  <Route path="/purchase_return" element={<PurchaseReturn />} />
                  <Route
                    path="/purchase_return_list"
                    element={<PurchaseReturnList />}
                  />
                  <Route
                    path="/purchase_enquiry"
                    element={<PurchaseEnquiry />}
                  />{" "}
                  <Route
                    path="/purchase_enquiry_list"
                    element={<PurchaseEnquiryList />}
                  />{" "}
                  <Route path="/work_order" element={<WorkOrder />} />{" "}
                  <Route path="/work_order_list" element={<WorkOrderList />} />
                  <Route path="/job_form" element={<JobForm />} />
                  <Route path="/invoice_list" element={<InvoiceList />} />
                  <Route path="/document_list" element={<DoList />} />
                  <Route
                    path="/document_list_logistic"
                    element={<DoLogisticList />}
                  />
                  <Route
                    path="/sales_order_list"
                    element={<SalesOrderList />}
                  />
                  <Route path="/quotationList" element={<QuotationList />} />
                  <Route
                    path="/salesreturnList"
                    element={<SalesReturnList />}
                  />
                  <Route
                    path="/purchaseInvoiceList"
                    element={<PurchaseInvoiceList />}
                  />
                  <Route path="/stock-list" element={<StockManagement />} />
                  <Route
                    path="/purchase_order_list"
                    element={<PurchaseOrderList />}
                  />
                  <Route
                    path="/sample_issue_list"
                    element={<SampleIssueList />}
                  />
                  <Route
                    path="/sample_return_list"
                    element={<SampleReturnList />}
                  />{" "}
                  <Route path="/sample_return" element={<SampleReturn />} />
                  <Route
                    path="/distribution_dashboard"
                    element={<DistributionDashboard />}
                  />
                  <Route
                    path="/production_dashboard"
                    element={<ProductionDashboard />}
                  />
                  <Route path="/production" element={<Production />} />
                  <Route
                    path="/assemble_disamble"
                    element={<AssembleDisamble />}
                  />
                  <Route path="/sample_issue" element={<SampleIssue />} />
                  <Route
                    path="/customer_visit_entry"
                    element={<VisitManager />}
                  />
                  <Route
                    path="/stock_transfer_in"
                    element={
                      <StockTransfer
                        documentType={DOCUMENT_TYPES.STOCKTRANSFERIN}
                      />
                    }
                  />
                  <Route
                    path="/stock_transfer_out"
                    element={
                      <StockTransfer
                        documentType={DOCUMENT_TYPES.STOCKTRANSFEROUT}
                      />
                    }
                  />
                  <Route
                    path="/branch_transfer"
                    element={
                      <StockTransfer
                        documentType={DOCUMENT_TYPES.BRANCH_TRANSFER}
                      />
                    }
                  />
                  <Route
                    path="/branch_transfer_in"
                    element={
                      <StockTransfer
                        documentType={DOCUMENT_TYPES.BRANCH_TRANSFER_IN}
                      />
                    }
                  />
                  <Route
                    path="/branch_transfer_list"
                    element={<BranchTransferList />}
                  />
                  <Route
                    path="/branch_transfer_in_list"
                    element={<BranchTransferInList />}
                  />
                  <Route
                    path="/stock_transfer_out_list"
                    element={<StockTransferOutList />}
                  />
                  <Route
                    path="/stock_transfer_in_list"
                    element={<StockTransferInList />}
                  />
                  <Route path="/goods_in_transit" element={<GitHome />} />
                  <Route path="/goods_in_transit_list" element={<GitList />} />
                  <Route path="/warranty_claim" element={<WarrantyClaim />} />
                  <Route
                    path="/warranty_claim_list"
                    element={<WarrantyClaimList />}
                  />
                  <Route
                    path="/trial_balance_report"
                    element={<TrialBalanceReport />}
                  />
                  <Route
                    path="/balance_sheet_report"
                    element={<BalanceSheetReport />}
                  />
                  <Route
                    path="/profit_and_loss_report"
                    element={<ProfitAndLossReport />}
                  />
                  <Route
                    path="/sales_analysis_report"
                    element={<SalesAnalysisReport />}
                  />
                  <Route
                    path="/invoice_profit_analysis_report"
                    element={<InvoiceProfitAnalysisReport />}
                  />
                  {/* jinu */}
                  <Route
                    path="/customer_control/gl_voucher_settings"
                    element={<GLVoucherSettings />}
                  />
                  <Route
                    path="/customer_control/g_and_l_management"
                    element={<GroupAndLedgerManagement />}
                  />
                  <Route element={<AdminRoute />}>
                    <Route path="/customer_control/roles" element={<Roles />} />
                    <Route path="/customer_control/users" element={<Users />} />
                    <Route
                      path="/customer_control/user_rights"
                      element={<UserRights />}
                    />
                    <Route
                      path="/customer_control/report_editor"
                      element={<HtmlEditor />}
                    />
                    <Route
                      path="/customer_control/gl_voucher_settings"
                      element={<GLVoucherSettings />}
                    />
                    <Route
                      path="/customer_control/g_and_l_management"
                      element={<GroupAndLedgerManagement />}
                    />
                    <Route
                      path="/customer_control/business_partner"
                      element={<BusinessPartner />}
                    />
                    <Route
                      path="/customer_control/business_partner_register"
                      element={<BusinessPartnerRegister />}
                    />
                    <Route
                      path="/customer_control/device_details"
                      element={<DeviceDetails />}
                    />
                  </Route>
                  <Route
                    path="/settings/application_utilities"
                    element={<ApplicationUtilities />}
                  />
                  <Route path="/stock_upload" element={<StockUpload />} />
                  {/* faizan */}
                  {/* <Route path="jobs" element={<Jobs />} /> */}
                  <Route path="jobs" element={<JobsDashboard />} />
                  <Route path="statements" element={<Statements />} />
                  <Route path="reciept" element={<Reciept />} />
                  <Route path="recieptView" element={<RecieptView />} />
                  <Route path="recieptPreview" element={<RecieptPreview />} />
                  <Route path="payment" element={<Payment />} />
                  <Route path="templates" element={<Templates />} />
                  <Route path="newJobForm" element={<NewJobForm />} />
                  <Route
                    path="contract_quot/:leadId"
                    element={<ContractQuotationScreen />}
                  />
                  <Route
                    path="contract_dashboard"
                    element={<ContractDashboard />}
                  />
                  <Route path="cheque_register" element={<ChequeRegister />} />
                  <Route
                    path="statementDocument"
                    element={<StatementPreview />}
                  />
                  <Route
                    path="outstandingDocument"
                    element={<OutstandingPreview />}
                  />
                  {/* <Route path="paymentDocument" element={<PaymentPreview />} /> */}
                  <Route path="paymentPreview" element={<PaymentPreview />} />
                  <Route path="paymentView" element={<PaymentView />} />
                  <Route path="voucher" element={<Voucher />} />
                  <Route path="voucherView" element={<VoucherView />} />
                  <Route path="voucherPrint" element={<VoucherPrint />} />
                  <Route
                    path="customerCreation"
                    element={<CustomerCreation />}
                  />
                  <Route
                    path="supplierCreation"
                    element={<SupplierCreation />}
                  />
                  <Route path="customerView" element={<CustomerView />} />
                  <Route
                    path="businessPartners"
                    element={<BusinessPartnersDashboard />}
                  />
                  <Route path="pdc" element={<PDCDashboard />} />
                  <Route path="pdcReportPrint" element={<PDCReportPrint />} />
                  <Route path="voucherAnalysis" element={<VoucherAnalysis />} />
                  <Route path="pettyCash" element={<PettyCash />} />
                  <Route path="pettyCashView" element={<PettyCashView />} />
                  <Route path="pettyCashPrint" element={<PettyCashPrint />} />
                  <Route path="itemCreation" element={<ItemCreation />} />
                  <Route
                    path="itemCreationAutoParts"
                    element={<ItemCreationAutoParts />}
                  />
                  <Route
                    path="salespersonCreation"
                    element={<SalespersonCreation />}
                  />
                  <Route
                    path="coordinatorCreation"
                    element={<CoordinatorCreation />}
                  />
                  <Route
                    path="financeApprovalDashboard"
                    element={<FinanceDashboard />}
                  />
                  {/* <Route path="ai_tutor" element={<AiTutor />} /> */}
                  {/* jinu latest path dec 13 */}
                  <Route
                    path="purchase_analysis_report"
                    element={<PurchaseAnalysisReport />}
                  />
                  <Route path="stockLedger" element={<StockLedgerMovement />} />
                  <Route
                    path="deliveryOrderReports"
                    element={<DeliveryOrderReports />}
                  />
                  <Route
                    path="salesOrderReports"
                    element={<SalesOrderReports />}
                  />
                  <Route path="crm_stage_report" element={<CRMStageReport />} />
                  <Route
                    path="salesman_performance_report"
                    element={<SalesmanPerformanceReport />}
                  />
                  <Route
                    path="bankReconciliation"
                    element={<BankReconciliation />}
                  />
                  <Route
                    path="financialAnalysisReport"
                    element={<FinancialAnalysisReport />}
                  />
                  <Route
                    path="logisticsManagementDashboard"
                    element={<LogisticManagementDashboard />}
                  />
                  <Route path="salesDashboard" element={<SalesDashboard />} />
                  <Route path="/einvoicing" element={<EInvoicingDashboard />} />
                  {/* <Route
                    path="financeMainDashboard"
                    element={<FinanceMainDashboard />}
                  /> */}
                  <Route path="financeMainDashboard" element={<HomeNew />} />
                  <Route path="billAllocation" element={<BillAllocation />} />
                  <Route
                    path="billAllocationMultiple"
                    element={<BillAllocationMultiple />}
                  />
                  <Route path="vat_report" element={<VATReport />} />
                  <Route path="stock_report" element={<StockReport />} />
                  <Route
                    path="location_transfer"
                    element={<LocationTransfer />}
                  />
                  <Route
                    path="location_transfer_list"
                    element={<LocationTransferList />}
                  />
                  <Route
                    path="location_transfer"
                    element={<LocationTransfer />}
                  />
                  <Route
                    path="location_transfer_list"
                    element={<LocationTransferList />}
                  />
                  <Route
                    path="physical_stock_entry"
                    element={<PhysicalStockEntry />}
                  />
                  <Route
                    path="physical_stock_view"
                    element={<PhysicalStockView />}
                  />
                  <Route
                    path="budget_allocation"
                    element={<BudgetAllocation />}
                  />
                  <Route path="budget_analysis" element={<BudgetAnalysis />} />
                  <Route
                    path="asset_register_list"
                    element={<AssetRegisterList />}
                  />
                  <Route path="register_asset" element={<RegisterAsset />} />
                  <Route
                    path="projectsDashboard"
                    element={<ProjectsDashboard />}
                  />
                  <Route
                    path="contract_quot"
                    element={<ContractingQuotation />}
                  />
                  <Route path="price_updater" element={<PriceUpdater />} />
                  <Route path="price_manager" element={<PriceManager />} />
                  <Route path="unit_master" element={<UnitMaster />} />
                  <Route path="area_code_master" element={<AreaCodeMaster />} />
                  <Route path="category_master" element={<CategoryMaster />} />
                  <Route
                    path="subcategory_master"
                    element={<SubcategoryMaster />}
                  />
                  <Route path="currency_master" element={<CurrencyMaster />} />
                  <Route path="group_master" element={<GroupMaster />} />
                  <Route path="subgroup_master" element={<SubgroupMaster />} />
                  <Route path="salesman_master" element={<SalesmanMaster />} />
                  <Route path="location_master" element={<LocationMaster />} />
                  <Route
                    path="common_master_creation"
                    element={<CommonMasterCreation />}
                  />
                  <Route
                    path="quotation_report"
                    element={<QuotationReport />}
                  />
                  {/* Real Estate Module Start*/}
                  <Route
                    path="buildingRegister"
                    element={<BuildingRegister />}
                  />
                  <Route
                    path="tenancyContractRegister"
                    element={<TenancyContractRegister />}
                  />
                  <Route
                    path="tenancyContractList"
                    element={<TenancyContractList />}
                  />
                  {/* <Route path="rentalUnitDashboard" element={<RentalUnitDashboard />} /> */}
                  <Route
                    path="rentalUnitDashboard"
                    element={<RentalUnitDashboardWrapper />}
                  />
                  <Route path="tenantRegister" element={<TenantRegister />} />
                  <Route path="tenantCreation" element={<TenantCreation />} />
                  <Route
                    path="contractAnalysis"
                    element={<ContractAnalysis />}
                  />
                  <Route path="rsInspection" element={<RSInspection />} />
                  <Route path="rsDashboard" element={<RSDashboard />} />
                  <Route path="rsrv" element={<RSRV />} />
                  <Route
                    path="receiptRealEstate"
                    element={<ReceiptRealEstate />}
                  />
                  <Route path="newReceipt" element={<NewReceipt />} />
                  <Route
                    path="recieptPreviewRE"
                    element={<RecieptPreviewRE />}
                  />
                  {/* Real Estate Module End*/}
                  <Route
                    path="report_designer_page"
                    element={<ReportDesignerPage />}
                  />
               
                </Route>
              </Route>

              <Route
                path="machine_registration"
                element={<MachineRegistration />}
              />
              {/* <Route path="landing_page" element={<LandingPage />} /> */}
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </main>
      </div>
    </div>
  );
}

function App() {
  return (
    <BreadcrumbsProvider>
      <Router>
        <PreviousRouteProvider>
          <AppContent />
        </PreviousRouteProvider>
      </Router>
    </BreadcrumbsProvider>
  );
}

export default App;
